import { useEffect } from "react";
import { useGastosCategorias } from "../../../contexto/provider/GastosCategoriasContext.js";

export default function CategoriasSeleccion({ value, onChange }) {
  const { categorias, listarCategorias, cargando, error } =
    useGastosCategorias();

  useEffect(() => {
    if (categorias.length === 0) {
      listarCategorias();
    }
  }, [categorias.length, listarCategorias]);

  return (
    <div className="campo-caja">
      <label>Item</label>

      <select
        className="selection"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Selecciona un gasto</option>

        {cargando && <option disabled>Cargando...</option>}

        {error && <option disabled>Error al cargar</option>}

        {categorias
          .filter((cat) => cat.activa)
          .map((cat) => (
            <option key={cat.id_categoria} value={cat.id_categoria}>
              {cat.nombre}
            </option>
          ))}
      </select>
    </div>
  );
}